var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4.43918C21 3.83337 21 3.53046 20.8802 3.3902C20.7763 3.26849 20.6203 3.2039 20.4608 3.21646C20.2769 3.23093 20.0627 3.44512 19.6343 3.8735L16 7.50781L19.6343 11.1421C20.0627 11.5705 20.2769 11.7847 20.4608 11.7992C20.6203 11.8117 20.7763 11.7471 20.8802 11.6254C21 11.4852 21 11.1823 21 10.5764V4.43918Z",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.30781C1 3.62766 1 2.78758 1.32698 2.14584C1.6146 1.58135 2.07354 1.12241 2.63803 0.834793C3.27976 0.507812 4.11984 0.507812 5.8 0.507812H11.2C12.8802 0.507812 13.7202 0.507812 14.362 0.834793C14.9265 1.12241 15.3854 1.58135 15.673 2.14584C16 2.78758 16 3.62766 16 5.30781V9.70781C16 11.388 16 12.228 15.673 12.8698C15.3854 13.4343 14.9265 13.8932 14.362 14.1808C13.7202 14.5078 12.8802 14.5078 11.2 14.5078H5.8C4.11984 14.5078 3.27976 14.5078 2.63803 14.1808C2.07354 13.8932 1.6146 13.4343 1.32698 12.8698C1 12.228 1 11.388 1 9.70781V5.30781Z",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.602220a737dbeef9aa47e21802afdf9c.svg";
export { ForwardRef as ReactComponent };